module.exports = __webpack_public_path__ + "static/media/infinity-blue.18090bbf.png";